import { _initialProjectsHealthWidget } from '../../../fixtures/projectFixtures'
import * as constants from '../actions/constants'
import { ProjectActions } from '../actions/projectActions'
import { ProjectsActions } from '../actions/projectsActions'
import { ICurrentProjectListEntry, IProject, IProjectFilters, IProjectsHealthWidget, IProjectTypeFilter } from '../types/project'
import {ITimeTrackingProject} from "../../time-tracking/types/timeTracking";

export const initialProjects: IProject[] = []
export const initialTimeTrackingProjects: ITimeTrackingProject[] = []
export const initialCurrentProjectsList: ICurrentProjectListEntry[] = []

export const projects = (state: IProject[] = initialProjects, action: ProjectsActions | ProjectActions): IProject[] => {
  switch (action.type) {
    case constants.GET_PROJECTS_SUCCESS:
      const projectList = action.projects.results || action.projects.filtered || []
      return projectList.map((pr) => {
        return {
          ...pr,
          phases: [...pr.phases].sort((a, b) => {
            const aStartDate = new Date(a.start_date).getTime()
            const bStartDate = new Date(b.start_date).getTime()
            const aEndDate = new Date(a.end_date).getTime()
            const bEndDate = new Date(b.end_date).getTime()
            return aStartDate !== bStartDate ? aStartDate - bStartDate : aEndDate - bEndDate
          }),
        }
      })

    case constants.CREATE_PROJECT_SUCCESS:
      return [...state, action.project]

    case constants.DELETE_PROJECT_SUCCESS:
      return state.filter((proj) => proj.id !== action.project.id)

    default:
      return state
  }
}

export const currentProjectsList = (
  state: ICurrentProjectListEntry[] = initialCurrentProjectsList,
  action: ProjectsActions
): ICurrentProjectListEntry[] => {
  switch (action.type) {
    case constants.GET_CURRENT_PROJECTS_SUCCESS:
      return action.projects
    default:
      return state
  }
}

export const projectsCountAll = (state = 0, action: ProjectsActions | ProjectActions): number => {
  switch (action.type) {
    case constants.GET_PROJECTS_SUCCESS:
      return action.projects.count || action.projects.all_count || 0

    default:
      return state
  }
}

export const projectsActiveCount = (state = 0, action: ProjectsActions | ProjectActions): number => {
  switch (action.type) {
    case constants.GET_PROJECTS_SUCCESS:
      return action.projects.active_count || 0

    default:
      return state
  }
}

export const filterProjects = (
  state: IProjectFilters = { search: undefined, order: undefined },
  action: ProjectsActions
): IProjectFilters => {
  switch (action.type) {
    case constants.FILTER_PROJECTS:
      return action.filters

    default:
      return state
  }
}

export const projectsHealthWidget = (
  state: IProjectsHealthWidget = _initialProjectsHealthWidget,
  action: ProjectsActions
): IProjectsHealthWidget => {
  switch (action.type) {
    case constants.GET_PROJECTS_HEALTH_WIDGET_SUCCESS:
      return action.widgetData

      default:
        return state
  }
}

export const _initialFilters: IProjectTypeFilter[] = [
  { key: 'all', name: 'All Projects', minWidth: '6.5rem' },
  { key: 'sponsor', name: 'Sponsor', minWidth: '6.5rem', count: 0 },
  { key: 'service_provider', name: 'Service Provider', minWidth: '9.5rem', count: 0 },
  { key: 'internal', name: 'Internal', minWidth: '6.5rem', count: 0 },
  { key: 'archive', name: 'Archive', minWidth: '6.5rem', count: 0 },
]

export const projectTypeFilters = (
  state: IProjectTypeFilter[] = _initialFilters,
  action: ProjectsActions
): IProjectTypeFilter[] => {
  switch (action.type) {
    case constants.GET_PROJECTS_SUCCESS:
      const projectList = action.projects.results || action.projects.filtered || []
      return state.map((f) => {
        if (f.key !== 'all' && f.key !== 'archive') {
          f.count = projectList.filter((p) => p.type === f.key && p.active).length
        }
        if (f.key === 'archive') {
          f.count = projectList.filter((p) => !p.active).length
        }
        return f
      })

    case constants.UPDATE_PROJECT_TYPE_FILTER_COUNTS:
      return state.map((f) => {
        if (f.key === 'all') {
          return { ...f, count: action.counts.all }
        }
        if (f.key === 'sponsor') {
          return { ...f, count: action.counts.sponsor }
        }
        if (f.key === 'service_provider') {
          return { ...f, count: action.counts.service_provider }
        }
        if (f.key === 'internal') {
          return { ...f, count: action.counts.internal }
        }
        if (f.key === 'archive') {
          return { ...f, count: action.counts.archive }
        }
        return f
      })

    default:
      return state
  }
}

export const projectTypeFilter = (
  state: IProjectTypeFilter = _initialFilters[0],
  action: ProjectsActions
): IProjectTypeFilter => {
  switch (action.type) {
    case constants.SET_PROJECT_TYPE_FILTER:
      return action.filter

    default:
      return state
  }
}

export const projectSort = (
  state: { name: string; direction: string } = { name: 'name', direction: 'asc' },
  action: ProjectsActions
): { name: string; direction: string } => {
  switch (action.type) {
    case constants.SORT_PROJECTS:
      return action.sort

    default:
      return state
  }
}

export const projectsTTList = (
  state: ITimeTrackingProject[] = initialTimeTrackingProjects,
  action: ProjectsActions | ProjectActions
): ITimeTrackingProject[] => {
  switch (action.type) {
    case constants.GET_PROJECTS_TT_LIST_SUCCESS:
      const ttProjectList = action.projects.filtered || []
      return ttProjectList.map((pr: ITimeTrackingProject) => {
        return {
          ...pr,
          phases: [...pr.phases].sort((a, b) => {
            const aStartDate = new Date(a.start_date).getTime()
            const bStartDate = new Date(b.start_date).getTime()
            const aEndDate = new Date(a.end_date).getTime()
            const bEndDate = new Date(b.end_date).getTime()
            return aStartDate !== bStartDate ? aStartDate - bStartDate : aEndDate - bEndDate
          }),
        }
      })

    case constants.CREATE_PROJECT_SUCCESS:
      return [
        ...state,
        {
          id: action.project.id,
          name: action.project.name,
          time_tracking_perm: action.project.time_tracking_perm,
          phases: action.project.phases,
          type: action.project.type,
          employees: action.project.employees,
          direct_costs: action.project.direct_costs,
          activities: action.project.activities,
          permissions: action.project.permissions,
          health: action.project.health,
          active: action.project.active,
          start_date: action.project.start_date,
          end_date: action.project.end_date,
          financial_calculation: action.project.financial_calculation,
          admins: action.project.admins,
          color: action.project.color
        }
      ]

    case constants.DELETE_PROJECT_SUCCESS:
      return state.filter((proj) => proj.id !== action.project.id)

    default:
      return state
  }
}
